export default {
	addPromotion: 'ADD_PROMOTION',
	addPromotionCarousel: 'ADD_PROMOTION_CAROUSEL',
	loading: 'LOADING_PROMOTION',
	error: 'ERROR_PROMOTION',
};
